export default __webpack_public_path__ + "static/media/FacturacionIconGreen.b8e81036.svg";